export const recurrence_options = [
    { value: 'DAILY', label: 'Daily' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'YEARLY', label: 'Yearly' },
    // { value: 'Workdays', label: 'Every Workday' },
    // { value: 'Every Weekday', label: 'Every Weekday' },
  ];
